export default __webpack_public_path__ + "static/thomas-907af988f6921f04a5adaa7230c27d65.jpg";